import React, {useContext} from 'react';
import { useEffect } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import config from './../../services/config.json';
import SimpleContext from './../context/SimpleContext';


const Brand = ({name, brandid,img}) => {

    const context = useContext(SimpleContext)
    const history = useHistory()
    
    useEffect(()=>{
    context.setSelectedBrandsList([])

    },[])


    //نمایش محصولات برندها
    const handleFilterProductsxt = (id,img,name) => {
        context.setsearchProducts({})
        context.setSelectedBrandsList([])
        context.setbrandName(id.name)
        context.setshowBrand(true)
        context.SelectedBrandsList.push(id.brandid)
        context.setBrandOfId(id.brandid)
        context.setSelectedBrandsList(context.SelectedBrandsList)
        context.setsearchBodyOfProduct({})
        history.push("/brandsProducts")
    }


    return ( 
        
        <div  onClick={()=>handleFilterProductsxt({brandid,img,name})} className="brandbtn">
            <img className="img_brand" 
            src={img}
            alt=""
            />
        </div>
        
     );
}
 
export default withRouter(Brand);
